<script>
import botService from '@/services/amio/bot.service'
import isEmpty from 'ramda/src/isEmpty'
import { ROUTE_NAMES } from '@/router'
import { ITEM_IDS } from '@/utils/editor.constants'
import { resolveLastOpenedBot } from '@/utils/last-opened-bot'

export default {
  name: 'Redirect',

  async beforeRouteEnter(to, from, next) {
    const bots = await botService.listBots()
    if (isEmpty(bots)) {
      return next({ name: ROUTE_NAMES.bots, params: { botId: ITEM_IDS.NEW } })
    }

    const bot = resolveLastOpenedBot(bots)
    return next({ name: ROUTE_NAMES.answers, params: { botId: bot.id } })
  }
}
</script>
